import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import React from 'react';

const DeleteBoxModal = ({ isOpen, onConfirm, onCancel }) => {
  return (
    <Modal isOpen={isOpen} toggle={onCancel}>
      <ModalHeader>Delete Edge Device?</ModalHeader>
      <ModalBody>
        <div>Do you really want to delete the box?</div>
        <div style={{ color: '#3b5aa9' }}>{/* Warning: This function cannot be undone! */}</div>
      </ModalBody>
      <ModalFooter>
        <Button outline color="secondary" onClick={onCancel}>
          No
        </Button>
        <Button color="primary" onClick={onConfirm}>
          Yes
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default DeleteBoxModal;
